/**
 * AI modülünün kabuğa tek giriş noktası: düğme + panel.
 *
 * Kabuk yalnızca bunu çiziyor; yetki kontrolü, panel durumu ve akış burada kapalı
 * kalıyor. Yetki yoksa hiçbir şey render edilmiyor (ağ isteği de yok).
 */
import { useAiAccess } from '../model/useAiAccess';
import { useAiStore } from '../model/aiStore';
import { AiChatFab } from './AiChatFab';
import { AiChatPanel } from './AiChatPanel';

export function AiHost() {
  const access = useAiAccess();
  const open = useAiStore((s) => s.open);
  const setOpen = useAiStore((s) => s.setOpen);

  // Sunucu hazır değilse düğme yalnız sistem rolünde çıkar (sebebi panelde yazılı).
  if (!access.available && !access.showDiagnostics) return null;

  return (
    <>
      <AiChatFab hidden={open} onClick={() => setOpen(!open)} />
      {open ? <AiChatPanel serverReady={access.serverReady} onClose={() => setOpen(false)} /> : null}
    </>
  );
}
